import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useFeatures } from 'context/FeatureContext';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const { flags } = useFeatures();
  const navGroups = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group': {
        // Drop items tied to a disabled feature flag.
        const children = item.children?.filter((child) => !child.feature || flags[child.feature]);
        return <NavGroup key={item.id} item={{ ...item, children }} />;
      }
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
